<template>
  <div>
    <el-row v-if="!isEditTimeOnly">
      <el-col>
        <el-steps :active="activeStep" process-status="finish" finish-status="success" simple>
          <el-step title="选择课程" :status="getStepStatus(0)" @click.native="onStepItemClick(0)"></el-step>
          <el-step title="选择时间" :status="getStepStatus(1)" @click.native="onStepItemClick(1)"></el-step>
          <el-step title="提交预约" :status="getStepStatus(2)" @click.native="onStepItemClick(2)"></el-step>
        </el-steps>
      </el-col>
    </el-row>
    <hr>
    <el-row class="grid-content">
      <el-col>
        <avappWorkflowStep1 ref="workflowStep1" v-if="!isEditTimeOnly" :isCompleted="isCompleted"
          v-show="activeStep === 0" :dataIn="step1Model"></avappWorkflowStep1>
        <avappWorkflowStep2 ref="workflowStep2" :isCompleted="isCompleted" :isReadOnly="isPayment"
          v-show="activeStep === 1" :dataIn="step2Model"></avappWorkflowStep2>
        <avappWorkflowStep3 ref="workflowStep3" v-if="!isEditTimeOnly" :isCompleted="isCompleted"
          v-show="activeStep === 2" :dataIn="step3Model"></avappWorkflowStep3>
      </el-col>
    </el-row>
    <el-row class="cs-filter-row">
      <el-col :span="20">
        <el-button v-if="activeStep > 0 && !isEditTimeOnly" :disabled="isSaving" size="medium" type="primary"
          @click="previous">上一步</el-button>
        <el-button
          v-if="((activeStep == 2 && !isCompleted) || activeStep < 2) && (!isPayment || (isPayment && activeStep < 2))"
          size="medium" :disabled="submitBtnDisable || isSaving" :type="submitBtnClass"
          @click="next">{{ submitBtnText }}</el-button>

        <!-- <span>为防止速成学员共享视频，观看视频时请务必携带一张<strong class="import-message">Photo ID</strong>，以便前台随机抽查</span> -->
        <el-button v-if="activeStep == 2 && isPayment" size="medium" :disabled="isSaving" type="primary"
          @click="onSavePayment">完成付款</el-button>
        <!-- <el-button v-if="!workflowData.IsCompleted && activeStep===2" size="medium" type="danger" @click="onCancelWorkflow">撤销</el-button> -->
      </el-col>
    </el-row>
    <el-dialog :center="true" :show-close="false" :close-on-click-modal="false" width="60%"
      :visible.sync="completedVisible" top="3vh" class="completedMessage">
      <avappSuccess :dataIn="avappSuccessData" @close="onCloseSuccess"></avappSuccess>
    </el-dialog>
  </div>
</template>

<script>
import avappWorkflowStep1 from "./avappWorkflowStep1";
import avappWorkflowStep2 from "./avappWorkflowStep2";
import avappWorkflowStep3 from "./avappWorkflowStep3";
import avappSuccess from "./avappSuccess";
import {
  createWorkflowModel,
  getVideoAppointment,
  saveWorkflowData,
  savePayment,
  getUniversityAllVideoPrice
} from "../../service/videoAppointment.service";
import { 
  getStudentCurrentTermCoursesForCategories,
  getStudentVideoDurationSettings
 } from "../../service/student.service";
import { getStore, setStore } from "../../config/mUtils";

export default {
  props: {
    id: Number,
    isPayment: Boolean
  },
  data() {
    return {
      loading: false,
      isEditTimeOnly: false,
      activeStep: 0,
      currentStep: 0,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      workflowData: {
        Step: 0
      },
      workflowOriginalData: {},
      step1Model: {},
      step2Model: {},
      step3Model: {},
      isSaving: false,
      isCompleted: false,
      avappSuccessData: {},
      completedVisible: false,
      isFreeForAll: true,
      studentCourseList: [],
      priceData:{
        supplementVideoPrice: 0,
        depositPrice: 0
      },
      studentVideoDurationSettings:[],
      studentVideoDurationText: ""
    };
  },
  components: {
    avappWorkflowStep1,
    avappWorkflowStep2,
    avappWorkflowStep3,
    avappSuccess
  },
  computed: {
    submitBtnText: function () {
      if (this.isEditTimeOnly) {
        return "保存";
      } else {
        let text = "下一步";
        if (this.activeStep === 2) {
          text = "完成并提交";
        }
        return text;
      }
    }
  },
  async created() {
    this.init();
  },
  methods: {
    init() {
      this.isEditTimeOnly = !this.USERMANAGER.isStudent;
      this.loadWorkflowData();
    },
    getStudentId(){
      let studentId = null;
      if (!this.USERMANAGER.isStudent) {
        studentId = this.workflowData.StudentId;
      }
      return studentId;
    },
    async loadStudentCourseList() {
      this.studentCourseList = [];
      let studentId = this.getStudentId();
      let courseCategoryList = [this.GLOBAL.enumNormalCourseCategory.OMO,
      this.GLOBAL.enumNormalCourseCategory.OfflineCourse];
      let result = await getStudentCurrentTermCoursesForCategories(courseCategoryList, studentId, true, true);
      if (!!result && result.success) {
        this.studentCourseList = result.data
      }
    },
    async loadPrice(){
      let studentId = this.getStudentId();
      let result = await getUniversityAllVideoPrice(studentId);
      this.isFreeForAll = !result.data.HasDeposit;
      this.priceData.supplementVideoPrice = result.data.SupplementVideoPrice;
      this.priceData.depositPrice = result.data.DepositPrice;
    },
    async loadWorkflowData() {
      let result = await getVideoAppointment(this.id);
      if (result && result.success) {
        this.workflowData = result.data;
        await this.loadStudentCourseList();
        await this.loadPrice();
        await this.loadStudentVideoDurationSettings();
        this.initStepModel();
      }
    },
    async loadStudentVideoDurationSettings(){
      let studentId = this.getStudentId();
      let result = await getStudentVideoDurationSettings(studentId);
      this.studentVideoDurationSettings = result.data;
      this.studentVideoDurationText = this.getStudentVideoDurationText();
    },
    getStudentVideoDurationText(){
      let text = "";
      for(let i = 0; i < this.studentVideoDurationSettings.length; i ++){
        let item = this.studentVideoDurationSettings[i];
        if (text.length > 0){
          text += "/";
        }
        if (item.CourseType === this.GLOBAL.courseType.vocationalTraining){
          text += `职业培训:${item.WatchingDuration}倍`;
        }else{
          text += `${item.CourseCategoryText}:${item.WatchingDuration}倍`;
        }
      }
      return text;
    },
    initStepModel() {
      if (!!this.workflowData) {
        this.isCompleted = this.workflowData.IsWorkflowCompleted;
        if (this.isCompleted && !this.isPayment) {
          this.activeStep = 1;
        } else {
          if (this.workflowData.Step > 2) {
            this.activeStep = 2;
          } else {
            this.activeStep = this.workflowData.Step;
          }
        }
      } else {
        this.isCompleted = false;
        this.activeStep = 0;
      }

      this.initStep1Model();
      this.initStep2Model();
      this.initStep3Model();
    },
    initStep1Model() {
      if (!!this.workflowData) {
        let courseId = this.workflowData.CourseId;
        if (courseId == 0) {
          courseId = "";
        }
        this.step1Model = {
          isFreeForAll: this.isFreeForAll,
          studentCourseList: this.studentCourseList,
          model: {
            studentId: this.workflowData.StudentId,
            courseId: courseId,
            courseName: this.workflowData.CourseName,
            courseActivationId: this.workflowData.CourseActivationId,
            minutes: this.workflowData.Minutes,
            date: this.workflowData.DateText,
            courseWeek: this.workflowData.Week,
            courseWeekString: this.workflowData.WeekText,
            availableMinutes: this.workflowData.AvailableMinutes,
            isOneHour: this.workflowData.IsOneHour,
            applicationType: this.workflowData.ApplicationType,
            applicationTypeText: this.workflowData.ApplicationTypeText,
            applicationDescription: this.workflowData.ApplicationDescription,
            isFree: this.workflowData.IsFree,
            price: this.workflowData.Price,
            fileList: this.workflowData.FileList,
            isOwnDevice: this.workflowData.IsOwnDevice,
            courseMinutes: this.workflowData.CourseMinutes,
            isUseTermFreeCount: this.workflowData.IsUseTermFreeCount
          },
          priceData: this.priceData,
          studentVideoDurationText: this.studentVideoDurationText
        };
      } else {
        this.step1Model = {
          isFreeForAll: this.isFreeForAll,
          studentCourseList: [],
          model: {
            studentId: 0,
            courseId: "",
            courseActivationId: 0,
            minutes: 0,
            date: "",
            courseWeek: 0,
            courseWeekString: "",
            availableMinutes: 0,
            applicationType: 0,
            applicationDescription: "",
            isFree: false,
            isOneHour: false,
            price: 0,
            fileList: [],
            isOwnDevice: false,
            courseMinutes: 0,
            isUseTermFreeCount: false
          },
          priceData: this.priceData,
          studentVideoDurationText: ""
        };
      }
    },
    initStep2Model() {
      let defaultModel = {
        campusId: "",
        campusName: "",
        appDate: "",
        appDateText: "",
        isOwnDevice: false,
        minutes: 0,
      };
      if (!!this.workflowData) {
        let schedule = this.workflowData.ScheduleList[0];
        let model = defaultModel;
        if (!!schedule) {
          model.campusId = schedule.CampusId;
          model.campusName = schedule.CampusName;
          model.appDateText = schedule.DateText;
        }

        let minutes = this.workflowData.Minutes;
        if (isNaN(minutes)) {
          minutes = 0;
        }

        if (minutes > 0) {
          let scale = 30;
          let count = Math.floor(minutes / scale);
          if (minutes % scale > scale / 2) {
            count++;
          }
          minutes = count * 30;
        }
        model.minutes = minutes;

        let isOwnDevice = this.workflowData.IsOwnDevice;
        let courseId = this.workflowData.CourseId;
        let course = this.studentCourseList.find(i => i.Id === courseId);
        let hasOwnDevice = true;
        if (course) {
          hasOwnDevice = course.HasOwnDevice;
        }
        if (!hasOwnDevice) {
          isOwnDevice = false;
        }
        model.isOwnDevice = isOwnDevice;

        this.step2Model = {
          isFreeForAll: this.isFreeForAll,
          studentId: this.workflowData.StudentId,
          videoAppointmentId: this.workflowData.Id,
          courseId: this.workflowData.CourseId,
          courseName: this.workflowData.CourseName,
          isOneHour: this.workflowData.IsOneHour,
          hasOwnDevice: hasOwnDevice,
          availableMinutes: this.workflowData.AvailableMinutes,
          courseMinutes: this.workflowData.CourseMinutes,
          model: model
        };
      } else {
        this.step2Model = {
          isFreeForAll: this.isFreeForAll,
          studentId: 0,
          videoAppointmentId: 0,
          courseId: 0,
          courseName: "",
          isOneHour: false,
          model: defaultModel
        };
      }
    },
    initStep3Model() {
      if (
        !!this.workflowData &&
        !!this.workflowData.ScheduleList &&
        this.workflowData.ScheduleList.length > 0
      ) {
        let schedule = this.workflowData.ScheduleList[0];
        let needPay = true;
        if (this.workflowData.Price > 0) {
          if (this.workflowData.IsWorkflowCompleted) {
            if (!this.isPayment) {
              needPay = false;
            }
          } else {
            // if (this.workflowData.ApplicationType == 1) {
            //   needPay = false;
            // }
          }
        } else {
          needPay = false;
        }

        let paymentEnable = this.checkPaymentEnable();
        this.step3Model = {
          isFreeForAll: this.isFreeForAll,
          videoAppointmentId: this.workflowData.Id,
          studentId: this.workflowData.StudentId,
          appDate: schedule.DateText,
          startTime: schedule.StartTimeText,
          endTime: schedule.EndTimeText,
          campusName: schedule.CampusName,
          computerName: schedule.ComputerName,
          courseName: this.workflowData.CourseName,
          weekText: this.workflowData.WeekText,
          isFree: this.workflowData.IsFree,
          price: this.workflowData.Price,
          needPay: needPay,
          paymentEnable: paymentEnable,
          isOwnDevice: this.workflowData.IsOwnDevice,
          minutes: this.workflowData.Minutes,
          availableMinutes: this.workflowData.AvailableMinutes,
          model: {
            balanceCost: this.workflowData.BalanceCost,
            bonusPointCost: this.workflowData.BonusPointCost,
            bonusPointPrice: this.workflowData.BonusPointPrice
          },
          studentVideoDurationText: this.studentVideoDurationText
        };
      } else {
        this.step3Model = {
          isFreeForAll: this.isFreeForAll,
          paymentEnable: true,
          videoAppointmentId: 0,
          studentId: 0,
          appDate: "",
          startTime: "",
          endTime: "",
          campusName: "",
          computerName: "",
          courseName: "",
          weekText: "",
          price: 0,
          isFree: false,
          isOwnDevice: false,
          minutes: 0,
          availableMinutes: 0,
          model: {
            balanceCost: 0,
            bonusPointCost: 0,
            bonusPointPrice: 0
          },
          studentVideoDurationText: []
        };
      }
    },
    setWorkflowModelDataFromStep() {
      if (this.activeStep > 2) {
        return;
      }

      if (this.isCompleted) {
        if (this.activeStep != 1) {
          return;
        }
      }

      switch (this.activeStep) {
        case 0: {
          this.workflowData.CourseId = this.step1Model.model.courseId;
          this.workflowData.CourseName = this.step1Model.model.courseName;
          this.workflowData.CourseActivationId = this.step1Model.model.courseActivationId;
          this.workflowData.DateText = this.step1Model.model.date;
          this.workflowData.Week = this.step1Model.model.courseWeek;
          this.workflowData.WeekText = this.step1Model.model.courseWeekString;
          this.workflowData.AvailableMinutes = this.step1Model.model.availableMinutes;
          this.workflowData.ApplicationType = this.step1Model.model.applicationType;
          this.workflowData.ApplicationDescription = this.step1Model.model.applicationDescription;
          this.workflowData.Price = this.step1Model.model.price;
          this.workflowData.FileList = this.step1Model.model.fileList;
          this.workflowData.IsOneHour = this.step1Model.model.isOneHour;
          this.workflowData.IsFree = this.step1Model.model.isFree;
          this.workflowData.CourseMinutes = this.step1Model.model.courseMinutes;
          this.workflowData.IsUseTermFreeCount = this.step1Model.model.isUseTermFreeCount;
          //this.workflowData.Minutes = this.step1Model.model.minutes;
          //this.workflowData.IsOwnDevice = this.step1Model.model.isOwnDevice;
          if (this.step1Model.model.isFree) {
            this.workflowData.Status = 1;
          }
          break;
        }
        case 1: {
          let data = this.$refs.workflowStep2.getData();
          this.workflowData.ScheduleList = [];
          this.workflowData.ScheduleList.push(data.schedule);
          this.workflowData.Minutes = this.step2Model.model.minutes;
          this.workflowData.IsOwnDevice = this.step2Model.model.isOwnDevice;
          break;
        }
        case 2: {
          let data = this.$refs.workflowStep3.getData();
          this.workflowData.BalanceCost = data.balanceCost;
          this.workflowData.BonusPointCost = data.bonusPointCost;
          this.workflowData.BonusPointPrice = data.bonusPointPrice;
          break;
        }
      }
      let step = this.activeStep + 1;
      if (step > 2) {
        step = 2;
      }
      if (step === 2) {
        this.workflowData.CheckOwnDeviceMaxNumber = true;
      } else {
        this.workflowData.CheckOwnDeviceMaxNumber = false;
      }

      if (this.workflowData.Step < step) {
        this.workflowData.Step = step;
      }
    },
    getStepStatus(step) {
      let stepStatus = "finish";

      if (step != this.activeStep) {
        stepStatus = "process";
        if (step < this.workflowData.Step) {
          stepStatus = "success";
        } else if (step > this.workflowData.Step) {
          stepStatus = "wait";
        } else if (this.workflowData.Step === 2 && step === 2) {
          stepStatus = "success";
        }
      }

      return stepStatus;
    },
    onStepItemClick(step) {
      if (step === this.activeStep || step > this.workflowData.Step) return;

      this.activeStep = step;
      this.refreshCalendar();
    },
    async previous() {
      this.activeStep--;
      this.refreshCalendar();
    },
    async next() {
      let isSuccess = await this.saveCurrentStep();

      if (isSuccess) {
        if (!this.isEditTimeOnly) {
          this.activeStep++;
          switch (this.activeStep) {
            case 1: {
              this.initStep2Model();
              break;
            }
            case 2: {
              this.initStep3Model();
              break;
            }
          }
        }

        this.refreshCalendar();
      }
    },
    validSave() {
      if (this.activeStep > 2) {
        return true;
      }
      let step = this.activeStep + 1;
      let name = "workflowStep" + step.toString();
      return this.$refs[name].valid();
    },
    async saveCurrentStep() {
      console.log("this.activeStep", this.activeStep);
      if (this.activeStep > 2 || this.isPayment) {
        return true;
      }
      let isOldCompleted = this.workflowData.IsWorkflowCompleted;
      if (this.workflowData.IsWorkflowCompleted) {
        if (this.activeStep != 1) {
          return true;
        }
      }

      if (!this.validSave()) {
        return false;
      }

      let isSave = true;
      switch (this.activeStep) {
        case 0:
          break;
        case 1:

          break;
        case 2:
          let courseId = this.workflowData.CourseId;
          let course = this.studentCourseList.find(i => i.Id === courseId);
          if (course && !course.HasOwnDevice && this.workflowData.IsOwnDevice) {
            this.$message.warning("当前课程不允许自带电脑/平板和耳机,请重新选择预约时间");
            return;
          }

          isSave = await this.$confirm("是否要完成预约?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              return true;
            })
            .catch(() => {
              return false;
            });
          if (isSave) {
            this.workflowData.IsWorkflowCompleted = true;
          }

          break;
      }

      if (!isSave) {
        return;
      }

      let isSuccess = true;
      this.loading = true;
      this.setWorkflowModelDataFromStep();

      this.isSaving = true;
      this.workflowData.ActiveStep = this.activeStep;
      let result = await saveWorkflowData(this.workflowData);
      if (!!this.workflowData.ScheduleList) {
        this.$refs.workflowStep2.loadScheduleList();
      }

      this.isSaving = false;
      if (!!result && result.success && !!result.data && !!result.data.Id) {
        this.workflowData.Id = result.data.Id;
        if (result.data.OverOwnDeviceMaxNumber) {
          this.$message.warning("自带电脑/平板和耳机已报名当前时间段超过50人，可能会没有空余座位。");
        }
        this.isCompleted = this.workflowData.IsWorkflowCompleted;

        this.workflowOriginalData = JSON.parse(
          JSON.stringify(this.workflowData)
        );

        if (!isOldCompleted && this.workflowData.IsWorkflowCompleted) {
          this.showCompletedDialog();
        }

        if (this.isEditTimeOnly) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
        }
      } else {
        this.workflowData.IsWorkflowCompleted = isOldCompleted;
        let message = result.message;
        if (!message) {
          message = "预约保存失败";
        }
        this.$message({
          message: message,
          type: "error"
        });
        isSuccess = false;
      }
      this.loading = false;

      return isSuccess;
    },
    onCancelWorkflow() {
      this.$confirm("是否撤销该流程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.removeCurrentWorkFlow();
        })
        .catch(() => { });
    },
    showCompletedDialog() {
      this.getSuccessData();
      this.completedVisible = true;
    },
    onCompletedDialogClose() {
      this.completedVisible = false;
    },
    removeCurrentWorkFlow() {
      // if (!!this.workflowData && !!this.workflowData.Id) {
      //   this.loading = true;
      //   removeWorkflow(this.workflowData.Id).then(result => {
      //     if (!!result && result.success) {
      //       this.$message({
      //         message: "撤销流程成功",
      //         type: "success"
      //       });
      //       this.activeStep = 0;
      //     } else {
      //       this.$message({
      //         message: result.message,
      //         type: "error"
      //       });
      //     }
      //     this.loading = false;
      //   });
      // }
    },
    getSuccessData() {
      if (
        !!this.workflowData &&
        !!this.workflowData.ScheduleList &&
        this.workflowData.ScheduleList.length > 0
      ) {
        let schedule = this.workflowData.ScheduleList[0];
        let isApprove = false;

        if (this.workflowData.Price > 0 && !this.isPayment) {
          if (this.workflowData.ApplicationType == 1) {
            isApprove = true;
          }
        }

        this.avappSuccessData = {
          date: schedule.DateText,
          startTime: schedule.StartTimeText,
          endTime: schedule.EndTimeText,
          campusName: schedule.CampusName,
          computerName: schedule.ComputerName,
          courseName: this.workflowData.CourseName,
          weekText: this.workflowData.WeekText,
          isApprove: isApprove,
          applicationDescription: this.workflowData.ApplicationDescription,
          fileList: this.workflowData.FileList
        };
      } else {
        this.avappSuccessData = {
          date: "",
          startTime: "",
          endTime: "",
          campusName: "",
          computerName: "",
          courseName: "",
          weekText: ""
        };
      }
    },
    onCloseSuccess() {
      this.$emit("close");
    },
    checkPaymentEnable() {
      let isEnable = false;
      if (this.isCompleted) {
        if (this.workflowData.Status == 5) {
          isEnable = true;
        }
      } else {
        isEnable = true;
      }

      return isEnable;
    },
    refreshCalendar() {
      if (this.activeStep == 1) {
        this.$nextTick(() => {
          this.$refs.workflowStep2.refreshCalendar();
        });
      }
    },
    onSavePayment() {
      if (this.$refs.workflowStep3.valid()) {
        let data = this.$refs.workflowStep3.getData();
        if (!!data) {
          savePayment(
            this.workflowData.Id,
            this.workflowData.Price,
            data.balanceCost,
            data.bonusPointCost,
            data.bonusPointPrice
          ).then(result => {
            if (result && result.success) {
              this.showCompletedDialog();
            } else {
              this.$message.error(result.message);
            }
          });
        }
      }
    },
  },
  watch: {
    id: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappWorkflowMain.vue